import type React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { MdClose } from "react-icons/md";
import sidebar from "../../../constants/sidebar";
import crest from "../../../assets/images/icons/logo.png";

type ISideBar = {
  open: boolean;
  onClose: () => void;
};

const SideBar: React.FC<ISideBar> = ({ open, onClose }) => {
  const location = useLocation();

  const isExactActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <aside
      className={`h-screen fixed inset-y-0 left-0 z-20 bg-primary-500 
        sm:relative sm:block sm:row-start-1 sm:row-end-3 sm:w-full 
        shadow-lg transition-all duration-300 ease-in-out
        ${open ? "w-[280px]" : "w-0 sm:w-full"}`}
    >
      <div className="flex flex-col h-full overflow-hidden">
        {/* Header */}
        <header className="flex items-center justify-between p-4 border-b border-white/30">
          <div className="flex-1">
            <img
              src={crest}
              alt="Corporate Setup Crest"
              className="h-10 object-contain"
            />
          </div>
          <button
            onClick={onClose}
            className="p-2 rounded-full hover:bg-primary-600 transition-colors sm:hidden"
            aria-label="Close sidebar"
          >
            <MdClose size={24} color="white" />
          </button>
        </header>

        {/* Main Navigation */}
        <nav className="flex-1 overflow-y-auto py-4 px-2">
          <div className="space-y-1">
            {sidebar.nav_links.map((item) => (
              <NavLink
                key={item.key}
                onClick={onClose}
                className={({ isActive }) =>
                  `flex items-center px-3 py-3 rounded-lg transition-all duration-200 
                  text-white font-medium group hover:bg-primary-600
                  ${
                    isActive || isExactActive(item.link)
                      ? "bg-primary-700 shadow-sm"
                      : ""
                  }`
                }
                to={item.link}
                end={item.link === "/dashboard"}
              >
                <div className="flex items-center justify-center ">
                  {/* <item.icon/>  */}
                  <item.icon className="h-6 w-6 object-contain transition-transform group-hover:scale-110" />
                </div>
                <span className="ml-3 sm:text-[1.25rem] sm:hidden md:block whitespace-nowrap">
                  {item.label}
                </span>
                {isExactActive(item.link) && (
                  <span className="ml-auto w-1.5 h-5 rounded-full bg-white/70 sm:hidden md:block"></span>
                )}
              </NavLink>
            ))}
          </div>
        </nav>

        {/* Settings Navigation */}
        <footer className="mt-auto">
          <div className="px-2 py-3 border-t border-white/30">
            <div className="space-y-1">
              {sidebar.settings.map((item) => (
                <NavLink
                  key={item.key}
                  onClick={onClose}
                  className={({ isActive }) =>
                    `flex items-center px-3 py-3 rounded-lg transition-all duration-200 
                    text-white font-medium group hover:bg-primary-600
                    ${isActive ? "bg-primary-600 shadow-sm" : ""}`
                  }
                  to={item.link}
                >
                  <div className="flex items-center justify-center ">
                    <item.icon className="h-6 w-6 object-contain transition-transform group-hover:scale-110" />
                  </div>
                  <span className="ml-3 sm:text-[1.25rem] sm:hidden md:block whitespace-nowrap">
                    {item.label}
                  </span>
                </NavLink>
              ))}
            </div>
          </div>
        </footer>
      </div>
    </aside>
  );
};

export default SideBar;
